module.exports = __webpack_public_path__ + "img/90095cf.png";